import { buildGanttScale } from "@/shared/components/gantt";
import type { GanttScale } from "@/shared/components/gantt";
import { fromDayNumber } from "@/modules/carga-trabalho";
import type { Timeline } from "@/modules/carga-trabalho";
import { resolveGanttLayout } from "@/ds";
import type { GanttLayout, GanttLayoutPreset } from "@/ds";

/**
 * A escala da base do Gantt (`Gantt.Root`) a partir da `Timeline` que as telas já calculam: o mesmo eixo, em dias,
 * então as posições em % (`left`/`width` dos itens) continuam valendo.
 */
export function ganttScaleOf(timeline: Timeline): GanttScale {
  return buildGanttScale({
    start: fromDayNumber(timeline.startDay),
    end: fromDayNumber(timeline.endDay),
    focusDay: timeline.focusDay,
  });
}

/** Largura mínima de cada mês (CSS) do layout: a do desktop, ou a do mobile. */
export function monthMinWidth(
  layout: GanttLayoutPreset | Partial<GanttLayout>,
  isMobile: boolean,
): string {
  const { monthWidthRem, monthWidthMobileRem } = resolveGanttLayout(layout);
  return `${isMobile ? monthWidthMobileRem : monthWidthRem}rem`;
}
